import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { getRouteVariants, getRouteTransition } from '@/utils/transitions';

export interface AnimatedRouteProps {
  children: ReactNode;
  className?: string;
}

export function AnimatedRoute({ children, className }: AnimatedRouteProps) {
  const variants = getRouteVariants();
  const transition = getRouteTransition();

  return (
    <motion.div
      data-testid="animated-route"
      className={className}
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={transition}
    >
      {children}
    </motion.div>
  );
}
